import { render, staticRenderFns } from "./mailLinkmanGet.vue?vue&type=template&id=a831037e&scoped=true&"
import script from "./mailLinkmanGet.vue?vue&type=script&lang=js&"
export * from "./mailLinkmanGet.vue?vue&type=script&lang=js&"
import style0 from "./mailLinkmanGet.vue?vue&type=style&index=0&id=a831037e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a831037e",
  null
  
)

export default component.exports